import { leadsOnBoardingService } from '@/services/leads.onboading.service';
import _ from 'lodash';

export const state = () => ({
    selectedProductId: '',
    selectedProductCategoryId: '',
    productConfigurator: [],
    productCategories: [],
    loading: false,
    onboardingWizard: [],
});


export const actions = {
    async fetchProductConfigurator({ commit }) {
        commit('setLoading', true);
        try {
            const response = await leadsOnBoardingService.getProductConfigurator();
            commit('setProductConfigurator', response.data.productConfigurator);
            commit('setProductCategories', response.data.productConfigurator);
        } catch (error) {
            console.error('Error fetching product configurator:', error);
        } finally {
            commit('setLoading', false);
        }
    },
}
export const mutations = {
    setselectedProductId(state, selectedProductId) {
        state.selectedProductId = selectedProductId;
    }
    ,
    setselectedProductCategoryId(state, selectedProductCategoryId) {
        state.selectedProductCategoryId = selectedProductCategoryId;
    },
    setProductConfigurator(state, productConfigurator) {
        state.productConfigurator = productConfigurator;
    },
    setProductCategories(state, productConfigurator) {
        state.productCategories = _.uniqBy(productConfigurator.map(item => ({
            value: item.productCategoryId,
            label: item.productCategoryName,
        })), 'value');
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
}
